const INITIAL_STATE = {
  chats: [],
};

/**
 * Types
 */
export const Types = {
  SEND_MESSAGE: 'chat/SEND_MESSAGE',
  INCLUDE_MESSAGE: 'chat/INCLUDE_MESSAGE',
  MESSAGE_RECEIVED: 'chat/MESSAGE_RECEIVED',
  MESSAGE_READ: 'chat/MESSAGE_READ',
  READ_MESSAGES: 'chat/READ_MESSAGES',
  START_TYPING: 'chat/START_TYPING',
  USER_START_TYPING: 'chat/USER_START_TYPING',
  STOP_TYPING: 'chat/STOP_TYPING',
  USER_STOP_TYPING: 'chat/USER_STOP_TYPING',
  INIT_CHAT_REQUEST: 'chat/INIT_CHAT_REQUEST',
  INIT_CHAT_SUCCESS: 'chat/INIT_CHAT_SUCCESS',
  DISCONECT_CHAT: 'chat/DISCONECT_CHAT',
  REMOVE_CHATS: 'chat/REMOVE_CHATS',
};

/**
 * Helpers
 */
export const getSocket = (state, chat_id) => {
  const { socket } = state.chat.chats.find(c => c.chat_id === chat_id) || {};
  return socket;
};

/**
 * Reducer
 */
export default function chat(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.INCLUDE_MESSAGE:
    case Types.MESSAGE_RECEIVED: {
      const { payload: message } = action;
      const { chat_id } = message;
      const chats = state.chats.map((c) => {
        if (c.chat_id === chat_id) return { ...c, messages: [...c.messages, message] };
        return c;
      });
      return { ...state, chats };
    }

    case Types.MESSAGE_READ: {
      const {
        payload: { messages, chat_id },
      } = action;
      const chats = state.chats.map((c) => {
        if (c.chat_id === chat_id) {
          return {
            ...c,
            messages: c.messages.map((msg) => {
              const message = messages.find(
                m => (m.text === msg.text && m.id === msg.id)
                  || (m.text === msg.text && !m.id),
              );
              if (message) {
                return { ...msg, is_read: true };
              }
              return msg;
            }),
          };
        }
        return c;
      });
      return { ...state, chats };
    }

    case Types.USER_START_TYPING: {
      const {
        payload: { chat_id },
      } = action;
      const chats = state.chats.map(c => (c.chat_id === chat_id ? { ...c, userTyping: true } : c));

      return { ...state, chats };
    }

    case Types.USER_STOP_TYPING: {
      const {
        payload: { chat_id },
      } = action;
      const chats = state.chats.map(c => (c.chat_id === chat_id ? { ...c, userTyping: false } : c));

      return { ...state, chats };
    }

    case Types.INIT_CHAT_SUCCESS:
      return { ...state, chats: [...state.chats, action.payload] };

    case Types.DISCONECT_CHAT:
      return { ...state, chats: state.chats.filter(c => c.chat_id !== action.payload.chat_id) };

    case Types.REMOVE_CHATS:
      return { ...state, chats: [] };

    default:
      return state;
  }
}

/**
 * Actions Creators
 */
export const Creators = {
  sendMessage: payload => ({
    type: Types.SEND_MESSAGE,
    payload,
  }),
  includeMessage: payload => ({
    type: Types.INCLUDE_MESSAGE,
    payload,
  }),
  messageReceived: payload => ({
    type: Types.MESSAGE_RECEIVED,
    payload,
  }),
  messageRead: payload => ({
    type: Types.MESSAGE_READ,
    payload,
  }),
  readMessages: payload => ({
    type: Types.READ_MESSAGES,
    payload,
  }),
  startTyping: payload => ({
    type: Types.START_TYPING,
    payload,
  }),
  stopTyping: payload => ({
    type: Types.STOP_TYPING,
    payload,
  }),
  userStartTyping: payload => ({
    type: Types.USER_START_TYPING,
    payload,
  }),
  userStopTyping: payload => ({
    type: Types.USER_STOP_TYPING,
    payload,
  }),
  initChatRequest: payload => ({
    type: Types.INIT_CHAT_REQUEST,
    payload,
  }),
  initChatSuccess: payload => ({
    type: Types.INIT_CHAT_SUCCESS,
    payload,
  }),
  disconectChat: payload => ({
    type: Types.DISCONECT_CHAT,
    payload,
  }),
  removeChats: payload => ({
    type: Types.REMOVE_CHATS,
    payload,
  }),
};
